// JsFromRoutes CacheKey 56d461ba3f1a9a6d2848943e62cdd7ee
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/god-mode/ai-prompts'),
  create: /* #__PURE__ */ definePathHelper('post', '/god-mode/ai-prompts'),
  update: /* #__PURE__ */ definePathHelper('patch', '/god-mode/ai-prompts/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/god-mode/ai-prompts/:id'),
}
